export const zoomOptions = {
    // Container for pan options
    pan: {
        // Boolean to enable panning
        enabled: false,
    },
    // Container for zoom options
    zoom: {
        // Boolean to enable zooming
        enabled: true,
        drag: {
           borderColor: '#3f51b5',
           borderWidth: 2,
           backgroundColor: '#c6cceb',
           animationDuration: 0
          },

        // Zooming directions. Remove the appropriate direction to disable 
        // Eg. 'y' would only allow zooming in the y direction
        mode: 'x',
    }
}